import { FC, useState } from "react";
import TextField from "../../Form/TextField";
import reload from "@iconify/icons-mdi/reload";
import IconButton from "../../Form/Button/IconButton";

export type CaptchaTypes = {
  onCaptchaAnswer?: Function;
  name: string;
  img?: string;
  onReload?: Function;
};

const Captcha: FC<CaptchaTypes> = (props) => {
  const { onCaptchaAnswer, name, img = "", onReload } = props;

  const [captcha, setCaptcha] = useState("");

  const handleChange = (value: string, name: string) => {
    setCaptcha(value);
    if (onCaptchaAnswer) {
      onCaptchaAnswer(value, name);
    }
  };

  const handleReload = () => {
    setCaptcha("");
    if (onCaptchaAnswer) {
      onCaptchaAnswer("", name);
    }
    if (onReload) {
      onReload();
    }
  };

  return (
    <div style={{ marginTop: 10, display: "flex", flexDirection: "row" }}>
      <TextField label="کدامنیتی" onChange={handleChange} name={name} required value={captcha} />
      <IconButton icon={reload} onClick={handleReload} type="button" />
      <img src={img} alt="captcha" style={{ height: "65%", marginTop: 5 }} />
    </div>
  );
};

export default Captcha;
